GP.collections.Friends = Backbone.Collection.extend({
    model:GP.models.User,
    comparator: function(user) {
        return (user.get('friendship') == "request") ? -user.get('rid') : -user.get('online');
    }
});
